import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { SimpleAlertDialogComponent, SimpleDialogData } from '../components/dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { getDatasetLockedDialogData, isDatasetLockedError } from './dataset-lock-util';
import { getDialogConfig } from './dialog-util';

export const getApiErrorDialogData = (error: any, translateService: TranslocoService, fallbackMessage?: string): SimpleDialogData => {
  if (isDatasetLockedError(error)) {
    return getDatasetLockedDialogData(error, translateService);
  }
  const detail: string | undefined = typeof error?.error === 'string' && error.error ? error.error : undefined;
  const messages = [fallbackMessage, detail].filter((message): message is string => !!message);
  return {
    title: translateService.translate('common.text.error'),
    messages: messages.length > 0 ? messages : [translateService.translate('errors.serverCommunicationError')],
    icon: 'error'
  };
};

export const showApiErrorDialog = (dialog: MatDialog, error: any, translateService: TranslocoService, fallbackMessage?: string) =>
  dialog.open(SimpleAlertDialogComponent, getDialogConfig(getApiErrorDialogData(error, translateService, fallbackMessage), '400px'));
